import { array, option } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { createElement } from 'react';
import { BillType, InvoicePaymentState, useRepositoryQuery } from '@mews-commander/data-access';
import { ActionType } from '@mews-commander/enums';
import { useDialogs } from '@mews-commander/ui';
import { REINSTATE_BILL_DIALOG_ID, ReinstateDialog } from '../../../../../modules/billing/reinstate';
import { BillHeadingAction } from './types';

interface ReinstateBillActionProps {
    action: BillHeadingAction<ActionType.ReinstateBill>;
    component: React.ElementType;
    close?: () => void;
}

export const ReinstateBillAction = ({ action, component, close }: ReinstateBillActionProps) => {
    const { openDialog } = useDialogs();
    const { data } = useRepositoryQuery('bills', 'getAll', { billIds: [action.billId] });
    const openReinstateDialog = () => {
        if (close) {
            close();
        }
        openDialog(<ReinstateDialog billId={action.billId} />, REINSTATE_BILL_DIALOG_ID);
    };

    const bill = pipe(data?.bills || [], array.head, option.toNullable);

    if (!bill) {
        return null;
    }

    if (bill.type === BillType.Invoice && bill.paymentState === InvoicePaymentState.PartiallyPaid) {
        return null;
    }

    return createElement(component, {
        'data-test-id': 'reinstate-bill-action',
        title: action.text,
        icon: action.icon,
        onClick: openReinstateDialog,
    });
};
